import { useDispatch } from "react-redux";

import { setNodeMultilingualPropertiesSelector, useNautilusSelector } from "../state/index.ts";

export const useSetMultilingualProperties = () => {
  const dispatch = useDispatch();
  return useNautilusSelector((state) => setNodeMultilingualPropertiesSelector(state, { dispatch }));
};
